import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PostCaseSavedLists } from "../api.js";

// The shape of the API's response
type SaveCaseListResult = {
  status: string;
  message?: string;
  errorCode?: string;
};

// What the hook's caller will pass in
type SaveCaseListPayload = {
  filterType: string;
  filterListName: string;
  filterList: string[];
};

export const usePostCaseSaveList = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation<
    SaveCaseListResult, // data
    unknown, // error
    SaveCaseListPayload & { token: string } // variables
  >({
    // sends POST /addCaseFilterList
    mutationFn: async ({
      filterType,
      filterListName,
      filterList,
      token,
    }) => {
      return PostCaseSavedLists(
        { filterType, filterListName, filterList },
        token
      );
    },

    onSuccess: (data) => {
      // e.g. show a toast or invalidateQueries(...)
    },
    onError: (error) => {
      // handle/report errors
    },
  });

  const mutate = useCallback(
    async (
      payload: SaveCaseListPayload,
      options?: {
        onSuccess?: (data: SaveCaseListResult) => void;
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      return mutation.mutateAsync(
        { ...payload, token },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate };
};
